import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { queryClient } from 'src/lib/query-client';
import { ConciergeErrorResponse } from 'src/api/concierge';

import { Event, EventsEndpoints, postCancelAttendanceEvent } from '../api';

export const usePostCancelAttendanceEvent = (
    id: string,
    config: UseMutationOptions<Event, AxiosError<ConciergeErrorResponse>> = {}
) => {
    const { onSuccess, ...restConfig } = config;

    return useMutation({
        mutationFn: () => postCancelAttendanceEvent(id),

        onSuccess(data, variables, context) {
            queryClient.setQueryData([EventsEndpoints.GetEvent, id], data);

            queryClient.invalidateQueries([EventsEndpoints.GetMyEvents]);
            queryClient.invalidateQueries([EventsEndpoints.GetEvents]);

            onSuccess?.(data, variables, context);
        },

        ...restConfig,
    });
};
